import React from 'react';

import MultiSelect, { useLabelTextMapper } from 'dashboard/components-lib/MultiSelect';
import { FieldSchemaMultiChoices } from 'lib/fields';

interface MultiChoicesFieldProps {
  accountSchema: FieldSchemaMultiChoices;
  value: string[];
  onChange: (value: string[]) => void;
  isDisabled: boolean;
}

const MultiChoicesField: React.FC<MultiChoicesFieldProps> = ({
  accountSchema,
  value,
  onChange,
  isDisabled,
}) => {
  const MULTI_CHOICES_OPTIONS = (accountSchema.config.options || []).map((option) => ({
    label: option,
    value: option,
  }));

  const multipleChoiceLabelTextMapper = useLabelTextMapper(MULTI_CHOICES_OPTIONS, 'options', {
    emptyIsAll: true,
    allSelectedLabel: `${accountSchema?.config?.options?.length} options`,
  });

  return (
    <MultiSelect
      value={value}
      searchEnabled
      selectAllEnabled
      selectOptionValues={MULTI_CHOICES_OPTIONS}
      labelTextMapper={multipleChoiceLabelTextMapper}
      onChange={onChange}
      disabled={isDisabled}
    />
  );
};

export default MultiChoicesField;
